module.exports = __webpack_public_path__ + "img/ice_rune.61d123dc.png";